import Util from '@/assets/libs/util'
import store from '@/store'

const loadSingleEvent = async function () {
  try {
    const events = store.getters.getEvents

    if (!events || events.length === 0) {
      await store.dispatch('loadEvents')
    }

    const event = store.getters.getEvents?.[0]

    if (!event) {
      Util.showErrorNotification('Nenhum evento disponível no momento.')
      return false
    }

    await store.dispatch('updateSelectedEvent', event)
    return {
      error: false,
      message: 'Evento carregado com sucesso',
      event
    }
  } catch (error) {
    return {
      error: true,
      message: 'Erro ao carregar o evento'
    }
  }
}

export {
  loadSingleEvent
}
